export const frameSetConfig = {
        alba: ['gw', 'gb', 'MA', 'MJ', 'SS', 'P', 'S'], 
        aria: ['G', 'P', 'S'],
        axes: ['G', 'P', 'S'], 
        blackjack: ['gw', 'gb', 'MA', 'MJ', 'SS', 'P', 'S'], 
}

export const buttonMaterialConfig = {
    G: {
        include: ["G"],
        exclude: ["gdg", "gpt", "gwm", "gbm", "gvt", "gvn"],
        extra: []
    },
    MA: {
        include: ["MA", "G"],
        exclude: ["gdg", "gpt", "gwm", "gbm", "gvt", "gvn"],
        extra: []
    },
    MJ: {
        include: ["MJ", "G"],
        exclude: ["gdg", "gpt", "gwm", "gbm", "gvt", "gvn"],
        extra: []
    },
    SS: {
        include: ["SS", "G"],
        exclude: ["gdg", "gpt", "gwm", "gbm", "gvt", "gvn"],
        extra: []
    },
    P: {
        include: ["P"],
        exclude: [],
        extra: []
    },
    S: {
        include: ["MA", "MJ", "SS", "G"],
        exclude: ["gdg", "gpt", "gwm", "gbm", "gvt", "gvn"],
        extra: []
    },
};

export const materialTitle = {
    G: "Glass",
    MA: "Aluminum",
    MJ: "Meljac",
    SS: "Stainless Steel",
    P: "Polymer",
    S: "Stone"
};


export const newMaterials = {
    G: [
        {
            label: "gdg",
            title: "Glass Mineral Texture",
            finishing_tech: "Digital",
            img: "images/finishing/1f_gdg.webp",
        },
        {
            label: "gpt",
            title: "Glass Space Marble",
            finishing_tech: "Paint",
            img: "images/finishing/1f_gpt.webp",
        },
        {
            label: "gw",
            title: "Glass Ice White",
            finishing_tech: "Paint",
            img: "images/finishing/1f_gw.webp",
        },
        {
            label: "gb", 
            title: "Glass York Black",
            finishing_tech: "Paint",
            img: "images/finishing/1f_gb.webp",
        },
        {
            label: "gwm",
            title: "Glass Mat White",
            finishing_tech: "Paint",
            img: "images/finishing/1f_gwm.webp",
        },
        {
            label: "gbm", 
            title: "Glass Mat Black",
            finishing_tech: "Paint",
            img: "images/finishing/1f_gbm.webp",
        },
         {
            label: "gvt",
            title: "Glass Terra",
            finishing_tech: "MVI",
            img: "images/finishing/1f_gvt.webp",
        },
        {
            label: "gvn", 
            title: "Glass Nero Marquina",
            finishing_tech: "MVI",
            img: "images/finishing/1f_gvn.webp",
        },
    ],
    MA: [
        {
            label: "mabb",
            title: "Aluminum Mars Black",
            finishing_tech: "ANOD",
            img: "images/finishing/1f_mabb.webp",
        },
        {
            label: "magt",
            title: "Aluminum Gold Bronze Matte",
            finishing_tech: "Paint",
            img: "images/finishing/1f_magt.webp",
        },
        {
            label: "maat",
            title: "Aluminum Arneis Satin",
            finishing_tech: "Paint",
            img: "images/finishing/1f_maat.webp",
        },
        {
            label: "mamt",
            title: "Aluminum Moka Stain",
            finishing_tech: "Paint",
            img: "images/finishing/1f_mamt.webp",
        },
        {
            label: "matt", 
            title: "Aluminum Rame Antico",
            finishing_tech: "Paint",
            img: "images/finishing/1f_matt.webp",
        },
        {
            label: "mant", 
            title: "Aluminum Noir Satin",
            finishing_tech: "Paint",
            img: "images/finishing/1f_mant.webp",
        },
        {
            label: "mast", 
            title: "Aluminum Mist Satin",
            finishing_tech: "Paint",
            img: "images/finishing/1f_mast.webp",
        },
        {
            label: "maet", 
            title: "Aluminum Atelier Bronze",
            finishing_tech: "Paint",
            img: "images/finishing/1f_maet.webp",
        },
        {
            label: "maht", 
            title: "Aluminum Heritage Brass",
            finishing_tech: "Paint",
            img: "images/finishing/1f_maht.webp",
        },
        {
            label: "makb", 
            title: "Aluminum Mars Black Satin",
            finishing_tech: "ANOD",
            img: "images/finishing/1f_makb.webp",
        },
        {
            label: "marb", 
            title: "Aluminum Cuvee Satin",
            finishing_tech: "ANOD",
            img: "images/finishing/1f_marb.webp",
        },
        {
            label: "mazb", 
            title: "Aluminum Bronze Satin",
            finishing_tech: "ANOD",
            img: "images/finishing/1f_mazb.webp",
        },
    ],
    MJ: [
        {
            label: "mjc",
            title: "Meljac Brass Champagne",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mjc.webp",
        },
        {
            label: "mjn",
            title: "Meljac Brass Nickel Brossé",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mjn.webp",
        },
        {
            label: "mja",
            title: "Meljac Brass Bronze Medaille Allemand",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mja.webp",
        },
        {
            label: "mjb",
            title: "Meljac Brass Nickel Noir Mat",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mjb.webp",
        },
        {
            label: "mjf",
            title: "Meljac Brass Bronze Medaille Fonce",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mjf.webp",
        },
        {
            label: "mjm",
            title: "Meljac Brass Chrome Vif (Mirror)",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mjm.webp",
        },
        {
            label: "mjv",
            title: "Meljac Brass Cuivre Antique",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mjv.webp",
        },
        {
            label: "mjs",
            title: "Meljac Brass Antique Brass",
            finishing_tech: "MJ",
            img: "images/finishing/1f_mjs.webp",
        },
    ],
    SS: [
        {
            label: "msdb",
            title: "Stainless Steel Gold Bronze",
            finishing_tech: "PVD+G",
            img: "images/finishing/1f_msdb.webp",
        },
        {
            label: "msrb",
            title: "Stainless Steel Rose Bronze",
            finishing_tech: "PVD+G",
            img: "images/finishing/1f_msrb.webp",
        },
        {
            label: "mszb",
            title: "Stainless Steel Antique Bronze",
            finishing_tech: "PVD+G",
            img: "images/finishing/1f_mszb.webp",
        },
        {
            label: "mssb",
            title: "Stainless Steel Rose Gold Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_mssb.webp",
        },
        {
            label: "msgb",
            title: "Stainless Steel Gold Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_msgb.webp",
        },
        {
            label: "mstb",
            title: "Stainless Steel Titanium Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_mstb.webp",
        },
        {
            label: "mscb",
            title: "Stainless Steel Champagne Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_mscb.webp",
        },
        {
            label: "msmb",
            title: "Stainless Steel Moka Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_msmb.webp",
        },
        {
            label: "msob",
            title: "Stainless Steel Copper Satin",
            finishing_tech: "PVD",
            img: "images/finishing/1f_msob.webp",
        },
        // {
        //     label: "mseb",
        //     title: "Stainless Steel Amber Copper",
        //     finishing_tech: "PVD",
        //     img: "images/finishing/1f_mseb.webp",
        // },
        {
            label: "msnb",
            title: "Stainless Steel Nikel Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_msnb.webp",
        },
        {
            label: "msbb",
            title: "Stainless Steel Obsidian Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_msbb.webp",
        },
        {
            label: "mskb",
            title: "Stainless Steel Kor-Ten Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_mskb.webp",
        },
        {
            label: "mspb",
            title: "Stainless Steel Graphite Brushed",
            finishing_tech: "PVD",
            img: "images/finishing/1f_mspb.webp",
        },
    ],
    P: [
        {
            label: "pt",
            title: "Polymer Rame Antico",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pt.webp",
        },
        {
            label: "pn",
            title: "Polymer Noir Satin",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pn.webp",
        },
        {
            label: "pm",
            title: "Polymer Moka Satin",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pm.webp",
        },
        {
            label: "pa",
            title: "Polymer Arneis Satin",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pa.webp",
        },
        {
            label: "ps",
            title: "Polymer Mist Satin",
            finishing_tech: "Paint",
            img: "images/finishing/1f_ps.webp",
        },
        {
            label: "pg",
            title: "Polymer Gold Bronze Matte",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pg.webp",
        },
        {
            label: "pe",
            title: "Polymer Atelier Bronze",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pe.webp",
        },
        {
            label: "ph",
            title: "Polymer Heritage Brass",
            finishing_tech: "Paint",
            img: "images/finishing/1f_ph.webp",
        },
        {
            label: "pw",
            title: "Polymer Mat White",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pw.webp",
        },
        {
            label: "pb",
            title: "Polymer Mat Black",
            finishing_tech: "Paint",
            img: "images/finishing/1f_pb.webp",
        },
    ],
    S: [
        {
            label: "sr",
            title: "Stone Travertino",
            finishing_tech: "Stone",
            img: "images/finishing/1f_sr.webp",
        },
        {
            label: "sa",
            title: "Stone Graphite",
            finishing_tech: "Stone",
            img: "images/finishing/1f_sa.webp",
        },
        {
            label: "sn",
            title: "Stone Nero Marquina",
            finishing_tech: "MDI",
            img: "images/finishing/1f_sn.webp",
        },
        {
            label: "sc",
            title: "Stone Carrara Bianco",
            finishing_tech: "MDI",
            img: "images/finishing/1f_sc.webp",
        },
        {
            label: "st",
            title: "Stone Terra",
            finishing_tech: "MDI",
            img: "images/finishing/1f_st.webp",
        },
        {
            label: "sp",
            title: "Stone Space Marbe",
            finishing_tech: "Paint on GRES",
            img: "images/finishing/1f_sp.webp",
        },
        
    ]
}

function getMaterialCategory(materialLabel) {
    return Object.keys(newMaterials).find(category =>
        newMaterials[category].some(material => material.label === materialLabel)
    );
}

const materialByLabel = Object.values(newMaterials)
    .flat()
    .reduce((acc, material) => {
        acc[material.label] = material;
        return acc;
    }, {});

export function resolveMaterials(selection) {
    return selection.reduce((acc, item) => {
        if (newMaterials[item]) {
            // Selection is a category key (e.g. "G", "P")
            acc[item] = newMaterials[item];
        } else if (materialByLabel[item]) {
            // Selection is an individual material label (e.g. "gdg")
            const material = materialByLabel[item];

            const group = Object.keys(newMaterials).find(key =>
                newMaterials[key].some(m => m.label === material.label)
            );

            if (group) {
                acc[group] ??= [];
                acc[group].push(material);
            }
        }

        return acc;
    }, {});
}

export function resolveButtonMaterials(frameMaterial) {
    const materialType = getMaterialCategory(frameMaterial);

    const config = buttonMaterialConfig[materialType] ?? {
        include: [],
        exclude: [],
        extra: []
    };

    const result = {};

    // Add categories
    config.include.forEach(category => {
        result[category] = [...newMaterials[category]];
    });

    // Add extra materials
    config.extra.forEach(label => {
        const material = materialByLabel[label];

        if (!material) return;

        const category = getMaterialCategory(label);

        result[category] ??= [];
        result[category].push(material);
    });

    // Remove excluded materials
    config.exclude.forEach(label => {
        Object.keys(result).forEach(category => {
            result[category] = result[category].filter(
                material => material.label !== label
            );
        });
    });

    return result;
}